export const PROFILE_USERNAME_REGEX =
  /^(?=.*[A-Za-z])[A-Za-z0-9_](?![_])(?!.*[_]{2})(?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,30}(?:[A-Za-z0-9_]))$/;
